export const AVATAR_API = "https://ui-avatars.com/api";
export const API = "https://king-prawn-app-hq64l.ondigitalocean.app/api";
// export const API = "http://localhost:1337/api";
export const API_Photo = "https://king-prawn-app-hq64l.ondigitalocean.app";
// export const API_Photo = "http://localhost:1337";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
